var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4287_1068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.76 8.62667C12.7867 8.42667 12.8 8.22 12.8 8C12.8 7.78667 12.7867 7.57333 12.7533 7.37333L14.1067 6.32C14.2267 6.22667 14.26 6.04667 14.1867 5.91333L12.9067 3.7C12.8267 3.55333 12.66 3.50667 12.5133 3.55333L10.92 4.19333C10.5867 3.94 10.2333 3.72667 9.83999 3.56667L9.59999 1.87333C9.57333 1.71333 9.43999 1.6 9.27999 1.6H6.71999C6.55999 1.6 6.43332 1.71333 6.40666 1.87333L6.16666 3.56667C5.77333 3.72667 5.41333 3.94667 5.08666 4.19333L3.49332 3.55333C3.34666 3.5 3.17999 3.55333 3.09999 3.7L1.82666 5.91333C1.74666 6.05333 1.77333 6.22667 1.90666 6.32L3.25999 7.37333C3.22666 7.57333 3.19999 7.79333 3.19999 8C3.19999 8.20667 3.21333 8.42667 3.24666 8.62667L1.89333 9.68C1.77333 9.77333 1.73999 9.95333 1.81333 10.0867L3.09333 12.3C3.17333 12.4467 3.33999 12.4933 3.48666 12.4467L5.07999 11.8067C5.41333 12.06 5.76666 12.2733 6.15999 12.4333L6.39999 14.1267C6.43333 14.2867 6.55999 14.4 6.71999 14.4H9.27999C9.43999 14.4 9.57333 14.2867 9.59333 14.1267L9.83333 12.4333C10.2267 12.2733 10.5867 12.06 10.9133 11.8067L12.5067 12.4467C12.6533 12.5 12.82 12.4467 12.9 12.3L14.18 10.0867C14.26 9.94 14.2267 9.77333 14.1 9.68L12.76 8.62667ZM7.99999 10.4C6.67999 10.4 5.59999 9.32 5.59999 8C5.59999 6.68 6.67999 5.6 7.99999 5.6C9.31999 5.6 10.4 6.68 10.4 8C10.4 9.32 9.31999 10.4 7.99999 10.4Z",
    fill: "#FFC444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4287_1068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6c76ee2cb0ca4953286b5b7f62f7f65a.svg";
export { ForwardRef as ReactComponent };